'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondBefore.js
// module id = 696
// module chunks = 0